module.exports = __webpack_public_path__ + "resource/img/image051Dark.f6375071.png";